module.exports = __webpack_public_path__ + "img/head.af8680dc.png";